export default __webpack_public_path__ + "static/media/MOIST_CARE_MILK_X.5f3bf0fb.png";